import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/audit",

        async list({ page, filters }) {
            const url = this.userUrl({
                path: `/page/${page}`
            });

            return Vue.http.post(url, {
                ...filters
            });
        },

        async operations() {
            return Vue.http.get("/audit/operations/");
        },

        async listUsers(search = "") {
            const url = this.userUrl({
                path: `/search/`
            });

            return Vue.http.get(url, {
                params: {
                    filter: search
                }
            });
        }
    },
    base
);
